export default {
  state: () => ({}),

  mutations: {},

  actions: {},

  namespaced: true
}
